import { forwardRef, ReactElement, Ref } from "react";
import { Box } from "@twilio-paste/core/box";
import { ChatComposer } from "@twilio-paste/core/chat-composer";
import { CustomizationProvider } from "@twilio-paste/core/customization";
import { $getRoot, OnChangeFunction } from "@twilio-paste/core/lexical-library";
import { Theme } from "@twilio-paste/core/theme";
import { types } from "./definitions";

const CompositeChatComposer = forwardRef(
  (
    { onChange, config, ...rest }: types.CompositeChatComposerProps,
    ref: Ref<HTMLDivElement>
  ): ReactElement => {
    const handleComposerChange: OnChangeFunction = (editorState) => {
      editorState.read(() => {
        const text = $getRoot().getTextContent();
        onChange(text);
      });
    };
    return (
      <Box as="div">
        <CustomizationProvider
          elements={{
            CHAT_COMPOSER: {
              boxShadow: "shadowLow",
              borderColor: "colorBorderWeaker",
              borderWidth: "borderWidth10",
              borderRadius: "borderRadius30",
              borderStyle: "solid",
              paddingY: "space50",
              paddingLeft: "space70",
              paddingRight: "space200",
            },
            CHAT_COMPOSER_PLACEHOLDER_WRAPPER: {
              top: "space50",
              left: "space70",
            },
          }}
        >
          <Theme.Provider theme="twilio">
            <ChatComposer
              config={config}
              ref={ref}
              onChange={handleComposerChange}
              {...rest}
            >
              {rest.children && rest.children}
            </ChatComposer>
          </Theme.Provider>
        </CustomizationProvider>
      </Box>
    );
  }
);

export default CompositeChatComposer;
